import Cookies from 'js-cookie';
import { environment } from '../config';

const BRAND_COOKIE_KEY = 'ohana_dev_brand';
const BRAND_COOKIE_EXPIRY_DAYS = 30;

export type BrandCode = 'MRR' | 'BVR' | 'DRS';

export interface BrandOption {
  code: BrandCode;
  domain: string;
  title: string;
  description: string;
}

// Available brand options for the selector
export const BRAND_OPTIONS: BrandOption[] = [
  {
    code: 'MRR',
    domain: 'ohana.mauiresortrentals.com',
    title: 'Maui Resort Rentals',
    description: 'Aloha and Welcome! - Maui operations'
  },
  {
    code: 'BVR',
    domain: 'ohana.beachviewrentals.com',
    title: 'Beachview Rentals',
    description: 'Welcome! - Newport Beach operations'
  },
  {
    code: 'DRS',
    domain: 'default',
    title: 'Dream Resorts (Default)',
    description: 'Default fallback brand for development'
  }
];


/**
 * Get the currently selected brand from cookies (development mode only)
 */
export function getSelectedBrandFromCookie(): string | null {
  if (!environment.debugMode) {
    return null;
  }

  return Cookies.get(BRAND_COOKIE_KEY) || null;
}

/**
 * Set the selected brand in cookies (development mode only)
 */
export function setSelectedBrandInCookie(brandDomain: string): void {
  if (!environment.debugMode) {
    return;
  }

  Cookies.set(BRAND_COOKIE_KEY, brandDomain, {
    expires: BRAND_COOKIE_EXPIRY_DAYS,
    sameSite: 'lax'
  });
}

/**
 * Clear the selected brand from cookies
 */
export function clearSelectedBrandCookie(): void {
  Cookies.remove(BRAND_COOKIE_KEY);
}

/**
 * Check if a brand has been selected in development mode
 */
export function hasBrandSelection(): boolean {
  if (!environment.debugMode) {
    return true; // In production, we always "have" a brand selection
  }

  const selectedBrand = getSelectedBrandFromCookie();
  return selectedBrand !== null;
}

/**
 * Get the brand option that matches a domain
 */
export function getBrandOptionByDomain(domain: string): BrandOption | null {
  return BRAND_OPTIONS.find(option => option.domain === domain) || null;
}

/**
 * Get the brand option that matches a brand code
 */
export function getBrandOptionByCode(code: BrandCode): BrandOption | null {
  return BRAND_OPTIONS.find(option => option.code === code) || null;
}

